import {
  SetSalesRate,
  SalesTiles,
  MonthlySales,
  CreateMonthlySales,
  MonthlySalesPlan,
  CreateMonthlySalesPlan,
  CreateMonthlyRmPlanning,
  CreateMonthyRmInput,
  MonthlyRmInputList,
  MonthlyRmplannigList,
  RmDescriptionList,
  RmTiles,
} from '../../pages/salesAndRm';

const salesAndRM = [
  {
    path: 'salesandplanning',
    element: <SalesTiles />,
  },
  {
    path: 'salesRateList',
    element: <SetSalesRate />,
  },
  {
    path: 'monthlySalesList',
    element: <MonthlySales />,
  },
  {
    path: 'createMonthlySales',
    element: <CreateMonthlySales />,
  },
  {
    path: 'monthlySalesPlanList',
    element: <MonthlySalesPlan />,
  },
  {
    path: 'createMonthlySalesPlan',
    element: <CreateMonthlySalesPlan />,
  },
  {
    path: 'rmandplanning',
    element: <RmTiles />,
  },
  {
    path: 'rmdescriptionlist',
    element: <RmDescriptionList />,
  },
  {
    path: 'monthlyrminput',
    element: <MonthlyRmInputList />,
  },
  {
    path: 'createmonthyrminput',
    element: <CreateMonthyRmInput />,
  },
  {
    path: 'monthlyrmplanniglist',
    element: <MonthlyRmplannigList />,
  },
  {
    path: 'createmonthlyrmplanning',
    element: <CreateMonthlyRmPlanning />,
  },
];

export { salesAndRM };
